import { grey } from "@mui/material/colors";

const styles = {
  dueChip: {
    ml: 1,
    fontSize: 12,
    backgroundColor: "white",
    color: "warning.main",
    border: "1px solid",
    borderColor: "warning.main",
  },
  card: {
    border: `1px solid`,
    borderColor: "purple.light",
  },
  archiveButton: {
    color: grey[300],
    fontSize: 14,
    width: 20,
    height: 20,
    position: "absolute",
    top: 10,
    right: 10,
  },
  text: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    WebkitLineClamp: 1,
    textOverflow: "ellipsis",
  },
};

export default styles;
